module.exports = __webpack_public_path__ + "static/media/mergeCardsLarge.66a0258b.svg";